'use strict'

import angular from 'angular'
import $ from "jquery";
import moment from 'moment'
import _ from 'lodash'

angular.module('buySheetConfig.ctrls', [])
    .controller('BuySheetConfigController', BuySheetConfigController)

BuySheetConfigController.$inject = ['$scope', '$rootScope', '$ioAlert', 'ClusterService', 'BuySheetConfigService', '$state', 'FormService', 'ErrorsHandler']

function BuySheetConfigController($scope, $rs, $ioAlert, ClusterService, BuySheetConfigService, $state, FormService, ErrorHandler) {
    const MAXIMUM_INSTANCES_COUNT = 5
    const FLAG_FOR_NEW_BUY_SHEET_TEMPLATE = -1

    const CLIENT_FIELDS_SECTION = 'clientFields'
    const ORDER_FIELDS_SECTION = 'orderFields'
    const PRODUCT_FIELDS_SECTION = 'productFields'
    const FLIGHT_FIELDS_SECTION = 'flightFields'

    let vm = this

    // TODO: refactor the modal out of here
    vm.is_field_selection_blocked = false
    vm.showModal = function (title, names, options) {
        let $modal = angular.element('#buy-sheet-config-model')
        vm.is_field_selection_blocked = true
        vm.buy_sheet_config_modal_title = title
        vm.buy_sheet_config_modal_names = names
        $modal.modal(_.assign(options, {
            show: true
        }), options)
    }

    let fieldAttributes = [], loadedFields = []
    vm.selectConfig = selectConfig
    vm.saveConfig = saveConfig
    vm.exportBuySheetTemplate = exportBuySheetTemplate
    vm.importBuySheetTemplate = importBuySheetTemplate
    vm.selectFields = selectFields
    vm.selectIcon = selectIcon
    vm.addSignature = addSignature
    vm.deleteSignature = deleteSignature
    vm.buySheetConfigsIds = []
    vm.selectedConfigId = -1
    vm.icon = ""
    vm.iconFields = [{
        label: "Platform",
        selected: false
    },
        {
            label: "Business Unit",
            selected: false
        }, {
            label: "Client",
            selected: false
        }
    ]
    vm.loadComplete = false
    vm.disableBtnAction = false

    initVmSelectedProperty()

    function initVmSelectedProperty() {
        vm.selected = {}
        vm.selected[CLIENT_FIELDS_SECTION] = []
        vm.selected[ORDER_FIELDS_SECTION] = []
        vm.selected[PRODUCT_FIELDS_SECTION] = []
        vm.selected[FLIGHT_FIELDS_SECTION] = []
    }

    function getConfigs() {
        BuySheetConfigService.getBuySheetTemplates().then(function (response) {
            vm.buySheetConfigsIds = response.buy_sheet_templates
            vm.selectedConfigId = vm.buySheetConfigsIds[0]
            selectConfig(vm.selectedConfigId)
        }, handleGetEntityFail)
    }

    function getFields(id) {
        getClientFields(id)
        getOrderFields(id)
        getProductFields(id)
        getFlightFields(id)
    }

    function getClientFields(id) {
        getSection(CLIENT_FIELDS_SECTION, id)
    }

    function getSection(name, id) {
        BuySheetConfigService[name](id).then(function(response) {
            initVmFields(response, name)
            setLoadedFields(name, id)
        }, handleGetEntityFail)
    }

    function initVmFields(response, name) {
        vm[name] = response && response[name] ? response[name] : []
    }

    function setLoadedFields(name, id) {
        loadedFields.push(name)
        if (loadedFields.length === 4) {
            getConfig(id)
        }
    }

    function handleGetEntityFail(response) {
        ErrorHandler.handle(response)
        $rs.loadingInProgress = false
        vm.loadComplete = true
    }


    function getOrderFields(id) {
        getSection(ORDER_FIELDS_SECTION, id)
    }

    function getProductFields(id) {
        getSection(PRODUCT_FIELDS_SECTION, id)
    }

    function getFlightFields(id) {
        getSection(FLIGHT_FIELDS_SECTION, id)
    }

    function getConfig(id) {
        BuySheetConfigService.getBuySheetTemplate(id).then(function (response) {
            if (response && response.buy_sheet_template) {
                setVmBasicConfigDataFormResponse(response.buy_sheet_template)
                vm.signatures = response.buy_sheet_template.signatures_attributes
                vm.text_area_1 = response.buy_sheet_template.text_area_1
                vm.text_area_2 = response.buy_sheet_template.text_area_2
                // Reset in case it's not the first time...
                fieldAttributes = []
                initVmSelectedProperty()

                _.each(response.buy_sheet_template.fields_attributes, function (attr) {
                    let section = attr.section
                    let field = _.find(vm[section], function (item) {
                        return item.field_name == attr.targetable_name && item.type === attr.targetable_type
                    })

                    if (field) {
                        field.selected = true
                        fieldAttributes.push({
                            "targetable_name": field.field_name,
                            "targetable_type": field.type,
                        })
                        vm.selected[field.section].push(field)
                    }
                })

                _.each(vm.iconFields, function (icon) {
                    if (icon.label == response.buy_sheet_template.logo_level) {
                        vm.selectIcon(icon)
                    }
                })

            } else {
                //If no template is configured
                vm.isNew = true
                vm.title = 'New Buysheet Config'
                vm.version_number = 1
                vm.signatures = []
            }
            $rs.loadingInProgress = false
            vm.loadComplete = true
            $('#buysheet-config-content').show()
        }, handleGetEntityFail)
    }

    function setVmBasicConfigDataFormResponse(buySheetTemplate) {
        vm.isNew = false
        vm.title = 'Buysheet Config ID#' + buySheetTemplate.id
        vm.version_number = buySheetTemplate.version_number
        vm.updated_at = moment(buySheetTemplate.updated_at).local().format('YYYY-MM-DD HH:mm')
    }

    /*
     * Select fields
     */
    function selectFields(field) {
        if (vm.is_field_selection_blocked) {
            return
        }

        field.selected = !field.selected
        if (field.selected) {
            fieldAttributes.push({
                "targetable_name": field.field_name,
                "targetable_type": field.type
            })
            vm.selected[field.section].push(field)
        } else {
            _.remove(fieldAttributes, function (attr) {
                return (attr.targetable_name == field.field_name && attr.targetable_type == field.type)
            })
            _.remove(vm.selected[field.section], function (attr) {
                return (attr.field_name == field.field_name && attr.type == field.type)
            })
        }
    }

    //Helper function to select icon level
    function selectIcon(field) {
        _.each(vm.iconFields, function (icon) {
            icon.selected = false
        })
        field.selected = true
        vm.icon = field.label
    }

    function addSignature() {
        vm.signatures.push({
            content: ""
        })
    }

    function deleteSignature(indexToDelete, idToDelete) {
        if (idToDelete) {
            BuySheetConfigService.deleteSignature(idToDelete).then(() => {
                removeSignatureFormCollection(indexToDelete)
            }, () => {
                $ioAlert.show('Error!', 'Signature could not be deleted', 'error')
            })

            return
        }

        removeSignatureFormCollection(indexToDelete)
    }

    function removeSignatureFormCollection(indexToDelete) {
        _.remove(vm.signatures, (signature, index) => {
            return index === indexToDelete
        })
    }

    function selectConfig(id) {
        $('#buysheet-config-content').hide()
        vm.selectedConfigId = id
        vm.text_area_1 = ''
        vm.text_area_2 = ''
        vm.signatures = []
        fieldAttributes = []
        loadedFields = []
        initVmSelectedProperty()
        getFields(id)
    }

    //Save or update the buysheet template config
    function saveConfig() {
        const obj = {}
        obj.fields_attributes = angular.copy(fieldAttributes)
        obj.text_area_1 = vm.text_area_1
        obj.text_area_2 = vm.text_area_2
        obj.signatures_attributes = vm.signatures
        obj.logo_level = vm.icon
        if (vm.isNew) {
            BuySheetConfigService.createBuySheetTemplate(obj).then(function (response) {
                $ioAlert.show('', 'Buysheet Configuration successfully created', 'success')
                vm.buySheetConfigsIds.pop()
                vm.buySheetConfigsIds.push(response.buy_sheet_template.id)
                if (vm.buySheetConfigsIds.length < MAXIMUM_INSTANCES_COUNT) {
                    vm.buySheetConfigsIds.push(FLAG_FOR_NEW_BUY_SHEET_TEMPLATE)
                }
                vm.selectedConfigId = response.buy_sheet_template.id
                setVmBasicConfigDataFormResponse(response.buy_sheet_template)

            }, ErrorHandler.handle)
        } else {
            BuySheetConfigService.updateBuySheetTemplate(vm.selectedConfigId, obj).then(function (response) {
                $ioAlert.show('', 'Buysheet Configuration successfully updated', 'success')
            }, ErrorHandler.handle)
        }
    }

    const saveData = (function () {
        const a = document.createElement("a")
        document.body.appendChild(a)
        a.style = "display: none"
        return function (data, fileName) {
            const json = angular.toJson(data),
                blob = new Blob([json], {type: "octet/stream"}),
                url = window.URL.createObjectURL(blob)
            a.href = url
            a.download = fileName
            a.click()
            window.URL.revokeObjectURL(url)
        }
    }())

    function exportBuySheetTemplate() {
        const obj = {}
        obj.fields_attributes = angular.copy(fieldAttributes)
        obj.text_area_1 = vm.text_area_1
        obj.text_area_2 = vm.text_area_2
        obj.signatures_attributes = []
        _.each(vm.signatures, function (signature) {
            obj.signatures_attributes.push({
                content: signature.content
            })
        })
        obj.logo_level = vm.icon
        saveData(obj, 'buySheetTemplate.json')
    }

    function importBuySheetTemplate() {
        if ($scope.uploadMedia.file && $scope.uploadMedia.file.length) {
            $ioAlert.show('', 'File is being uploaded, please do not refresh the page', 'success')
            const reader = new FileReader()

            reader.onload = function (e) {
                const obj = JSON.parse(e.target.result)
                if (vm.isNew) {
                    BuySheetConfigService.createBuySheetTemplate(obj).then(function (response) {
                        $ioAlert.show('', 'Buysheet Configuration imported and saved successfully', 'success')
                        $rs.loadertitle = "Fetching Template Configurations..."
                        $rs.loadingInProgress = true
                        selectConfig(response.buy_sheet_template.id)
                    }, ErrorHandler.handle)
                } else {
                    BuySheetConfigService.updateBuySheetTemplate(vm.id, obj).then(function (response) {
                        $ioAlert.show('', 'Buysheet Configuration imported and updated successfully', 'success')
                        $rs.loadertitle = "Fetching Template Configurations..."
                        $rs.loadingInProgress = true
                        selectConfig(response.buy_sheet_template.id)
                    }, ErrorHandler.handle)
                }
            }

            reader.onerror = function (evt) {
                switch (evt.target.error.code) {
                    case evt.target.error.NOT_FOUND_ERR:
                        $ioAlert.show('Error!', 'File not found', 'error')
                        break
                    case evt.target.error.NOT_READABLE_ERR:
                        $ioAlert.show('Error!', 'File is not readable', 'error')
                        break
                    case evt.target.error.ABORT_ERR:
                        break // noop
                    default:
                        $ioAlert.show('Error!', 'An error occurred reading this file. ' + evt.target.error.code, 'error')
                }
            }

            reader.readAsText($scope.uploadMedia.file[0])
        }
    }

    /*
     * Handle get instance lock configuration
     */
    function getInstanceLockConfig() {
        FormService.getInstanceLockConfig().then(function (data) {
            vm.disableBtnAction = !!data.instanceLocked
        }, ErrorHandler.handle)
    }

    function init() {
        $rs.loadingInProgress = true
        $rs.loadertitle = "Fetching Template Configurations"
        ClusterService.initCluster($rs.userRole, 'hidden')
        getInstanceLockConfig()
        getConfigs()
    }

    init()
}